import { render } from "./NavigationBarRec.vue?vue&type=template&id=3ab629fb"
import script from "./NavigationBarRec.vue?vue&type=script&lang=js"
export * from "./NavigationBarRec.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__